<template>
  <el-dialog :visible.sync="isModalVisible" :show-close="false" :close-on-click-modal="false">
    <span slot="title" class="font-weight-bold h4" >
      <div class="d-flex justify-content-center">
        <h3 v-if="isModalVisible && isCancelingOrder"> Cancel Order </h3>
        <h3 v-if="isModalVisible && isConfirmingOrder"> Confirm Order </h3>
        <h3 v-if="isModalVisible && !isConfirmingOrder && !isCancelingOrder"> Edit Order </h3>
      </div>
    </span>
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <el-row type="flex" justify="center" v-if="isCancelingOrder">
          <el-col :span="2">
            <i v-show="isModalVisible" class="fa fa-exclamation-triangle text-danger" style="font-size: 50px"></i>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" :class="{ 'pt-5' : isCancelingOrder }">
          <el-col :span="20">
            <h6 class="text-center font-weight-bold py-1" v-if="!isCancelingOrder && !isCancelingOrder">
              This will send a notification to your customer to inform them of the change.
            </h6>
            <h6 class="text-center font-weight-bold py-1" v-if="isCancelingOrder">
              This will send a notification to your customer.
            </h6>
            <h6 class="text-center font-weight-bold py-1" v-if="isConfirmingOrder">
              Confirming the order will send an email notification to the customer.
            </h6>
            <h6 class="text-center font-weight-bold py-1" v-if="!isConfirmingOrder">
              Would you like to continue?.
            </h6>
            <h6 class="text-center font-weight-bold py-1">
              You can also add a (optional) message using the form below
            </h6>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" class="pt-2">
      <el-col :span="20" class="text-center">
        <el-input
          type="textarea"
          :rows="6"
          placeholder="Enter message.."
          v-model="customerFeedback">
        </el-input>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer-center">
      <el-row :gutter="20">
        <el-button size="small" type="info" @click="cancelSave"
          > {{ isComingFromOrderCapture ? 'Close' : 'Back' }}</el-button
        >
        <el-button size="small" :type="isCancelingOrder ? 'danger' : 'success'" @click="confirmSave" :loading="btnLoading"
          >Send Notification</el-button
        >
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import breakpoint from "@/mixins/index";
import { updateOrder, updateOrderStatus } from "@/api/orders";
import { formatStringToNumber } from "@/util/util";
import moment from 'moment';

export default {
  components: {},
  mixins: [breakpoint],
  props: {
    orderId: {
      type: String,
      required: true,
      default: "",
    },
    orderToUpdate: {
      type: Object,
      required: true,
      default: () => {},
    },
    isCancelingOrder: {
      type: Boolean,
      required: false,
      default: false,
    },
    viewEditDeleteConfirmationDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    viewEditOrderDialogVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    viewEditOrderDialog: {
      type: Boolean,
      required: false
    },
    isBunkering: {
      type: Boolean,
      required: false,
      default: false,
    },
    isConfirmingOrder: {
      type: Boolean,
      required: false,
      default: false
    },
    isComingFromOrderCapture: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      customerFeedback: "",
      orderData: null,
      btnLoading: false,
      isModalVisible: true,
    };
  },
  computed: {},
  mounted() {
    this.orderData = JSON.parse(JSON.stringify(this.orderToUpdate));
  },
  methods: {
    displayPreviousModal() {
      this.isModalVisible = false;
      this.$emit('update:isCancelingOrder', false);
      setTimeout(() => {
        this.$emit('update:viewEditOrderDialogVisible', true);
        this.$emit('update:viewEditDeleteConfirmationDialog', false);
      }, 150);
    },
    cancelSave() {
      if (this.isComingFromOrderCapture) {
        this.$emit('closeEditOrderDialog')
      } else {
        this.displayPreviousModal();
      }
    },
    formatLiftingPeriodToDate(date) {
      if (date) {
        return `${moment(date, "DD/MM/YYYY").format("YYYY-MM-DD")}T12:00:00.000000Z`
      }
    },
    async confirmSave() {
      this.btnLoading = true;
      try {
        if (this.isCancelingOrder) {
          updateOrderStatus(this.orderId, { orderCancelled: true, feedback: this.customerFeedback }).then(this.handleResponse)
        } else if (this.isConfirmingOrder) {
          updateOrderStatus(this.orderId, { status: "CONFIRMED", feedback: this.customerFeedback }).then(this.handleResponse)
        } else {
          await this.createOrderDTO();
          if (this.isBunkering) {
            this.formatDTOforBunkering();
          }
          const tempOrder = {...this.orderData};
          delete tempOrder.liftingPeriod;
          updateOrder(this.orderId, tempOrder, this.customerFeedback).then(this.handleResponse);
        }
      } catch (ex) {
        console.dir(ex);
        this.displayPreviousModal();
      }
    },
    formatDTOforBunkering() {
      this.orderData.offers.forEach(async element => {
        delete element.collectionTime;
        delete element.liftingPeriod;
      });
    },
    async createOrderDTO() {
      await this.orderData.offers.forEach(async element => {
        element.liftingPeriod = [this.formatLiftingPeriodToDate(this.orderData.liftingPeriod[0]), this.formatLiftingPeriodToDate(this.orderData.liftingPeriod[1])],
        element.price = formatStringToNumber(element.price),
        element.quantityOrdered = formatStringToNumber(element.quantityOrdered),
        element.collectionTime = -1
      });
    },
    handleResponse(res){
      if (res.status === 200) {
        this.btnLoading = false;
        this.$emit("closeEditOrderDialog");
      } else {
        this.displayPreviousModal();
      }
    }
  },
};
</script>
<style>
</style>